var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Chip, InputLabel, TextField, Typography, useMediaQuery } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { LanguageListAPI, VIContactPreferencePickListAPI, getCustomerByIdAPI, syncCustomerUpdateURL, updateCustomerInfoAPI } from "../../api/url";
import { DEFAULT_MOB_NO_REGEX, EParentModuleName, LOCAL_STORAGE_KEYS, defaultMobile } from "../../constants";
import { VerifyMobile } from "../../modules/commonViews/verifyMobile/verifyMobile";
import { showLoader, showNotification } from "../../redux/commonSlice";
import { createAPI, getByIdAPI, setState, updateAPI } from "../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { getLocalStorageItem, setLocalStorageItem } from "../../utils/storageHelper";
import useAnalyticsEventTracker from "../../utils/useAnalyticsEventTracker";
import { GoogleAnlyticsErrorLog, MuiAutocomplete } from "../../utils/utils";
import { isNullOrEmpty, validateEmail } from "../../utils/validationHelper";
import { MuiAvatar } from "../atoms/avatarComponent";
import { MuiButton } from "../atoms/buttonComponent";
import { InputBox } from "../atoms/input";
import { MuiLoaderButton } from "../atoms/loaderButton";
import { MuiSelectComponent } from "../atoms/muiSelectComponent";
import { MuiStack } from "../atoms/stackComponent";
import { MuiForm, MuiUseForm } from "../molecules/customForm";
import { MuiPopup } from "../molecules/popupComponent";
var initialValues = {
    email: "",
    language: "",
    otp: "",
    contactPreferences: []
};
var EditCustomerInfo = function (props) {
    var _getCustomerInfo$data, _getCustomerInfo$data2, _getCustomerInfo$data6, _getCustomerInfo$data7, _getCustomerInfo$data8, _getCustomerInfo$data9, _getCustomerInfo$data10, _getCustomerInfo$data11, _getCustomerInfo$data12, _getCustomerInfo$data13, _getCustomerInfo$data14, _getCustomerInfo$data15, _getCustomerInfo$data16, _getCustomerInfo$data17, _getCustomerInfo$data18, _getCustomerInfo$data19, _getCustomerInfo$data20, _ContactPreferrenceLi2;
    var open = props.open, onClose = props.onClose, data = props.data, isDisabled = props.isDisabled, isInvalidMobile = props.isInvalidMobile, onUpdateClose = props.onUpdateClose, setEditCustomerFlag = props.setEditCustomerFlag, vehicleDetails = props.vehicleDetails, parentDocumentName = props.parentDocumentName;
    var dispatch = useAppDispatch();
    var _a = useState(""), primaryNumber = _a[0], setPrimaryNumber = _a[1];
    var _b = useState(""), alternateNumber = _b[0], setAlternateNumber = _b[1];
    var _c = useAppSelector(function (state) { return state.crud; }), ContactPreferrenceList = _c.ContactPreferrenceList, LanguageList = _c.LanguageList, getCustomerInfo = _c.getCustomerInfo, documentDetailsGetById = _c.documentDetailsGetById, isTimerActive = _c.isTimerActive;
    var primaryContact = getCustomerInfo === null || getCustomerInfo === void 0 || (_getCustomerInfo$data = getCustomerInfo.data) === null || _getCustomerInfo$data === void 0 || (_getCustomerInfo$data = _getCustomerInfo$data.PersonContactPoint) === null || _getCustomerInfo$data === void 0 ? void 0 : _getCustomerInfo$data.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ContactType) === "Primary"; });
    var secondaryContact = getCustomerInfo === null || getCustomerInfo === void 0 || (_getCustomerInfo$data2 = getCustomerInfo.data) === null || _getCustomerInfo$data2 === void 0 || (_getCustomerInfo$data2 = _getCustomerInfo$data2.PersonContactPoint) === null || _getCustomerInfo$data2 === void 0 ? void 0 : _getCustomerInfo$data2.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ContactType) === "Secondary"; });
    var _d = useState(primaryContact !== null && primaryContact !== void 0 && primaryContact.IsMobileVerified ? primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.IsMobileVerified : false), primaryVerifiedStatus = _d[0], setPrimaryVerifiedStatus = _d[1];
    var _e = useState(secondaryContact !== null && secondaryContact !== void 0 && secondaryContact.IsAlternateNumberVerified ? secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.IsAlternateNumberVerified : false), alternateNumberVerifiedStatus = _e[0], setAlternateVerifiedStatus = _e[1];
    var _f = useState(false), validationMessage = _f[0], setValidationMessage = _f[1];
    var MobileNoRegex = getLocalStorageItem(LOCAL_STORAGE_KEYS.MOBILE_NO_REGEX);
    var isEmailVerified = getLocalStorageItem(LOCAL_STORAGE_KEYS.IS_EMAIL_VERIFIED);
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var trackButtonClick = useAnalyticsEventTracker('EditCustomerInfo');
    var validate = function () {
        var fieldValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : values;
        var temp = _objectSpread({}, errors);
        if ("email" in fieldValues)
            temp.email = fieldValues.email ? !validateEmail(fieldValues.email) ? t("EMAIL_VALIDATION_MESSAGE") : "" : "";
        setErrors(_objectSpread({}, temp));
        if (fieldValues === values)
            return Object.values(temp).every(function (x) { return x === ""; });
    };
    var _g = MuiUseForm(initialValues, true, validate, true), values = _g.values, errors = _g.errors, setErrors = _g.setErrors, setValues = _g.setValues, handleInputChange = _g.handleInputChange;
    useEffect(function () {
        getCommunicationTypeLists();
    }, []);
    useEffect(function () {
        setPrimaryVerifiedStatus(primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.IsMobileVerified);
        setAlternateVerifiedStatus(secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.IsAlternateNumberVerified);
    }, [primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.IsMobileVerified, secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.IsAlternateNumberVerified]);
    useEffect(function () {
        getCommunicationDetails();
    }, [LanguageList, getCustomerInfo, ContactPreferrenceList]);
    var handleClose = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _vehicleDetails$;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(createAPI({
                        key: 'syncCustomerUpdate',
                        url: syncCustomerUpdateURL,
                        request: {
                            CustomerId: data === null || data === void 0 ? void 0 : data.CustomerId,
                            VinNo: vehicleDetails === null || vehicleDetails === void 0 || (_vehicleDetails$ = vehicleDetails[0]) === null || _vehicleDetails$ === void 0 ? void 0 : _vehicleDetails$.VinNo
                        }
                    }))];
                case 1:
                    _a.sent();
                    onClose();
                    setValues(initialValues);
                    setPrimaryNumber("");
                    setAlternateNumber("");
                    setPrimaryVerifiedStatus(false);
                    setAlternateVerifiedStatus(false);
                    setValidationMessage(false);
                    trackButtonClick("ButtonClickEvent", "Customer_Cancel_Click", undefined);
                    return [2 /*return*/];
            }
        });
    }); };
    var getCommunicationTypeLists = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _profileData$data$Bra, _documentDetailsGetBy, request, storedCommunicationTypeList, _communicationTypesLi, _communicationTypesLi2, _communicationTypesLi3, communicationTypesListResponse, _communicationTypesLi4, _communicationTypesLi5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        OrganizationId: profileData === null || profileData === void 0 || (_profileData$data$Bra = profileData.data.Branches[0]) === null || _profileData$data$Bra === void 0 ? void 0 : _profileData$data$Bra.OrganizationId,
                        ProductId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy = documentDetailsGetById.data) === null || _documentDetailsGetBy === void 0 ? void 0 : _documentDetailsGetBy.ProductId
                    };
                    storedCommunicationTypeList = getLocalStorageItem(LOCAL_STORAGE_KEYS.COMMUNICATION_TYPES_LIST);
                    if (!(storedCommunicationTypeList && storedCommunicationTypeList.data)) return [3 /*break*/, 1];
                    dispatch(setState({
                        key: "ContactPreferrenceList",
                        value: storedCommunicationTypeList
                    }));
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: 'ContactPreferrenceList',
                        url: VIContactPreferencePickListAPI
                    }))];
                case 2:
                    communicationTypesListResponse = _a.sent();
                    if (communicationTypesListResponse !== null && communicationTypesListResponse !== void 0 && (_communicationTypesLi = communicationTypesListResponse.payload) !== null && _communicationTypesLi !== void 0 && _communicationTypesLi.value && communicationTypesListResponse !== null && communicationTypesListResponse !== void 0 && (_communicationTypesLi2 = communicationTypesListResponse.payload) !== null && _communicationTypesLi2 !== void 0 && (_communicationTypesLi2 = _communicationTypesLi2.value) !== null && _communicationTypesLi2 !== void 0 && _communicationTypesLi2.success && communicationTypesListResponse !== null && communicationTypesListResponse !== void 0 && (_communicationTypesLi3 = communicationTypesListResponse.payload) !== null && _communicationTypesLi3 !== void 0 && (_communicationTypesLi3 = _communicationTypesLi3.value) !== null && _communicationTypesLi3 !== void 0 && _communicationTypesLi3.data) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.COMMUNICATION_TYPES_LIST, communicationTypesListResponse === null || communicationTypesListResponse === void 0 || (_communicationTypesLi4 = communicationTypesListResponse.payload) === null || _communicationTypesLi4 === void 0 ? void 0 : _communicationTypesLi4.value);
                        dispatch(setState({
                            key: "ContactPreferrenceList",
                            value: communicationTypesListResponse === null || communicationTypesListResponse === void 0 || (_communicationTypesLi5 = communicationTypesListResponse.payload) === null || _communicationTypesLi5 === void 0 ? void 0 : _communicationTypesLi5.value
                        }));
                    }
                    _a.label = 3;
                case 3:
                    dispatch(getByIdAPI({
                        key: 'LanguageList',
                        url: LanguageListAPI,
                        request: request
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var getCommunicationDetails = function () {
        var _getCustomerInfo$data3, _LanguageList$data, _getCustomerInfo$data5;
        var customerContactPreferences = getCustomerInfo === null || getCustomerInfo === void 0 || (_getCustomerInfo$data3 = getCustomerInfo.data) === null || _getCustomerInfo$data3 === void 0 ? void 0 : _getCustomerInfo$data3.PersonContactPreference;
        var ContactPreferences = [];
        customerContactPreferences === null || customerContactPreferences === void 0 || customerContactPreferences.forEach(function (eve) {
            var _ContactPreferrenceLi;
            ContactPreferrenceList === null || ContactPreferrenceList === void 0 || (_ContactPreferrenceLi = ContactPreferrenceList.data) === null || _ContactPreferrenceLi === void 0 || _ContactPreferrenceLi.forEach(function (event) {
                if (eve.CommunicationTypeId === event.id) {
                    ContactPreferences === null || ContactPreferences === void 0 || ContactPreferences.push(event);
                }
            });
        });
        var matchedLanguage = LanguageList === null || LanguageList === void 0 || (_LanguageList$data = LanguageList.data) === null || _LanguageList$data === void 0 || (_LanguageList$data = _LanguageList$data.find(function (_it) {
            var _getCustomerInfo$data4;
            return _it.LanguageId === (getCustomerInfo === null || getCustomerInfo === void 0 || (_getCustomerInfo$data4 = getCustomerInfo.data) === null || _getCustomerInfo$data4 === void 0 ? void 0 : _getCustomerInfo$data4.LanguageId);
        })) === null || _LanguageList$data === void 0 ? void 0 : _LanguageList$data.LanguageId;
        setValues(_objectSpread(_objectSpread({}, values), {}, {
            language: matchedLanguage,
            contactPreferences: ContactPreferences,
            email: getCustomerInfo === null || getCustomerInfo === void 0 || (_getCustomerInfo$data5 = getCustomerInfo.data) === null || _getCustomerInfo$data5 === void 0 ? void 0 : _getCustomerInfo$data5.Email
        }));
    };
    var getCustomerData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = (data === null || data === void 0 ? void 0 : data.CustomerId);
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'getCustomerInfo',
                            url: getCustomerByIdAPI(data === null || data === void 0 ? void 0 : data.CustomerId)
                        }))];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    _a;
                    return [2 /*return*/];
            }
        });
    }); };
    var handleContactPreferenceChange = function (e, value) {
        setValues(function (val) { return _objectSpread(_objectSpread({}, val), {}, {
            contactPreferences: value
        }); });
    };
    var updateCustomerAPICall = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _vehicleDetails$2, _data$CustomerId, _response$payload, _response$payload2, request, response, _data$CustomerId2, _response$error, _response$error2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    request = {
                        PersonContactPoints: [{
                                MobileNo: primaryNumber,
                                Email: values === null || values === void 0 ? void 0 : values.email,
                                ContactType: "Primary",
                                IsMobileVerified: primaryVerifiedStatus
                            }, {
                                MobileNo: alternateNumber ? alternateNumber : defaultMobile,
                                Email: values === null || values === void 0 ? void 0 : values.Email,
                                ContactType: "Secondary",
                                IsAlternateNumberVerified: alternateNumberVerifiedStatus
                            }],
                        VinNo: vehicleDetails === null || vehicleDetails === void 0 || (_vehicleDetails$2 = vehicleDetails[0]) === null || _vehicleDetails$2 === void 0 ? void 0 : _vehicleDetails$2.VinNo,
                        PersonContactPreferences: values.contactPreferences.map(function (item) { return item === null || item === void 0 ? void 0 : item.id; }),
                        PersonLanguages: {
                            LanguageId: values !== null && values !== void 0 && values.language ? values === null || values === void 0 ? void 0 : values.language : null,
                            IsDefaultCommunication: false
                        }
                    };
                    return [4 /*yield*/, dispatch(updateAPI({
                            key: 'updateCustomerInfo',
                            url: updateCustomerInfoAPI((_data$CustomerId = data.CustomerId) !== null && _data$CustomerId !== void 0 ? _data$CustomerId : ""),
                            request: request
                        }))];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 ? void 0 : _response$payload.statusCode) == 200 || response !== null && response !== void 0 && (_response$payload2 = response.payload) !== null && _response$payload2 !== void 0 && _response$payload2.success) {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("Updated successfully"),
                            type: "success"
                        }));
                        getCustomerData();
                        if (onUpdateClose) {
                            onUpdateClose();
                        }
                        if (setEditCustomerFlag) {
                            setEditCustomerFlag(false);
                        }
                    }
                    else {
                        GoogleAnlyticsErrorLog(profileData, updateCustomerInfoAPI((_data$CustomerId2 = data.CustomerId) !== null && _data$CustomerId2 !== void 0 ? _data$CustomerId2 : ""), response === null || response === void 0 || (_response$error = response.error) === null || _response$error === void 0 ? void 0 : _response$error.message, request);
                        dispatch(showNotification({
                            isOpen: true,
                            message: response === null || response === void 0 || (_response$error2 = response.error) === null || _response$error2 === void 0 ? void 0 : _response$error2.message,
                            type: "error"
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleUpdateClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var regEmail, regMob;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    regEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                    regMob = MobileNoRegex ? MobileNoRegex : DEFAULT_MOB_NO_REGEX;
                    regMob = new RegExp(regMob);
                    if (!primaryNumber) {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Please enter primary no.");
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Please enter primary no.",
                            type: "error"
                        }));
                        return [2 /*return*/];
                    }
                    if (isEmailVerified === "true" && isNullOrEmpty(values === null || values === void 0 ? void 0 : values.email)) {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Please enter email id");
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Please enter email id",
                            type: "error"
                        }));
                        return [2 /*return*/];
                    }
                    if (primaryNumber.length < 10 || primaryNumber === defaultMobile || !regMob.test(primaryNumber)) {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Enter valid primary no.");
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Enter valid primary no.",
                            type: "error"
                        }));
                        return [2 /*return*/];
                    }
                    if (alternateNumber && (alternateNumber.length < 10 || !regMob.test(alternateNumber))) {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Enter valid secondary no.");
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Enter valid secondary no.",
                            type: "error"
                        }));
                        return [2 /*return*/];
                    }
                    if (values.email && !regEmail.test(values.email.trim())) {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Enter valid email id");
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Enter valid email id",
                            type: "error"
                        }));
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, updateCustomerAPICall()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: open,
        onClose: handleClose,
        closeIcon: isInvalidMobile ? false : true,
        title: t('Edit customer information'),
        variant: "h1",
        subTitle: t("Please enter details of the customer"),
        subTitleVariant: "h4",
        subTitleStyle: {
            color: "#8593A3"
        },
        containerStyle: {
            width: lgMode ? '500px' : 'calc(90vw)',
            paddingTop: 0,
            paddingX: '22px'
        },
        showLoaderOnPopup: true
    }, /*#__PURE__*/ React.createElement(MuiForm, null, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        direction: "column",
        marginTop: '10px'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(MuiAvatar, {
        id: "customer-profile-img",
        sx: {
            height: 64,
            width: 64
        }
    })), /*#__PURE__*/ React.createElement(InputLabel, null, t("First name")), /*#__PURE__*/ React.createElement(InputBox, {
        id: "firstName",
        size: "small",
        style: {
            marginTop: '8px'
        },
        value: getCustomerInfo !== null && getCustomerInfo !== void 0 && (_getCustomerInfo$data6 = getCustomerInfo.data) !== null && _getCustomerInfo$data6 !== void 0 && (_getCustomerInfo$data6 = _getCustomerInfo$data6.Person) !== null && _getCustomerInfo$data6 !== void 0 && _getCustomerInfo$data6.GivenName ? getCustomerInfo === null || getCustomerInfo === void 0 || (_getCustomerInfo$data7 = getCustomerInfo.data) === null || _getCustomerInfo$data7 === void 0 || (_getCustomerInfo$data7 = _getCustomerInfo$data7.Person) === null || _getCustomerInfo$data7 === void 0 ? void 0 : _getCustomerInfo$data7.GivenName : "",
        name: "Firstname",
        onChange: handleInputChange,
        disabled: true
    }), /*#__PURE__*/ React.createElement(InputLabel, null, t("Last name")), /*#__PURE__*/ React.createElement(InputBox, {
        id: "lastName",
        size: "small",
        style: {
            marginTop: '8px'
        },
        value: getCustomerInfo !== null && getCustomerInfo !== void 0 && (_getCustomerInfo$data8 = getCustomerInfo.data) !== null && _getCustomerInfo$data8 !== void 0 && (_getCustomerInfo$data8 = _getCustomerInfo$data8.Person) !== null && _getCustomerInfo$data8 !== void 0 && _getCustomerInfo$data8.FamilyName ? getCustomerInfo === null || getCustomerInfo === void 0 || (_getCustomerInfo$data9 = getCustomerInfo.data) === null || _getCustomerInfo$data9 === void 0 || (_getCustomerInfo$data9 = _getCustomerInfo$data9.Person) === null || _getCustomerInfo$data9 === void 0 ? void 0 : _getCustomerInfo$data9.FamilyName : "",
        name: "lastName",
        onChange: handleInputChange,
        disabled: true
    }), /*#__PURE__*/ React.createElement(InputLabel, null, t("Primary mobile no.")), /*#__PURE__*/ React.createElement(VerifyMobile, {
        Primary: (primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.MobileNumber) === defaultMobile ? "" : primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.MobileNumber,
        verficationTickPrimary: primaryVerifiedStatus,
        setVerificationTickPrimary: function (value) {
            setPrimaryVerifiedStatus(value);
        },
        onMobileNumberChange: function (e) { return setPrimaryNumber(e); },
        disabled: isDisabled,
        vehicleDetail: vehicleDetails,
        setValidationMessage: setValidationMessage
    }), (getCustomerInfo === null || getCustomerInfo === void 0 || (_getCustomerInfo$data10 = getCustomerInfo.data) === null || _getCustomerInfo$data10 === void 0 ? void 0 : _getCustomerInfo$data10.MobileNumber) !== defaultMobile && !primaryVerifiedStatus && primaryNumber !== '' && !isDisabled && !validationMessage ? /*#__PURE__*/ React.createElement(Typography, {
        id: "primary-mobile-no-helper-text",
        variant: "subtitle2",
        color: 'red'
    }, "Primary mobile no. linked to the customer is not verified.") : /*#__PURE__*/ React.createElement(React.Fragment, null), (getCustomerInfo === null || getCustomerInfo === void 0 || (_getCustomerInfo$data11 = getCustomerInfo.data) === null || _getCustomerInfo$data11 === void 0 ? void 0 : _getCustomerInfo$data11.MobileNumber) === defaultMobile && parentDocumentName !== EParentModuleName.Jobcard && (primaryNumber === defaultMobile || primaryNumber === '') ? /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle2",
        color: 'red'
    }, "Please enter primary mobile no. ") : /*#__PURE__*/ React.createElement(React.Fragment, null), /*#__PURE__*/ React.createElement(InputLabel, null, t("Secondary mobile no.")), /*#__PURE__*/ React.createElement(VerifyMobile, {
        Alternate: (secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.MobileNumber) === defaultMobile ? "" : secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.MobileNumber,
        isAlternateNumber: true,
        verficationTickAlternate: alternateNumberVerifiedStatus,
        setVerificationTickAlternate: function (value) {
            setAlternateVerifiedStatus(value);
        },
        onAlternateMobileNumberChange: function (e) { return setAlternateNumber(e); },
        disabled: isDisabled,
        vehicleDetail: vehicleDetails
    }), /*#__PURE__*/ React.createElement(InputLabel, null, t("Email")), /*#__PURE__*/ React.createElement(InputBox, {
        id: "email-id",
        name: "email",
        size: "small",
        placeholder: "Enter email",
        style: {
            marginTop: '8px'
        },
        inputProps: {
            maxLength: 100
        },
        value: values.email,
        onChange: handleInputChange,
        disabled: isDisabled,
        error: errors.email
    }), isEmailVerified === "true" && !(getCustomerInfo !== null && getCustomerInfo !== void 0 && (_getCustomerInfo$data12 = getCustomerInfo.data) !== null && _getCustomerInfo$data12 !== void 0 && _getCustomerInfo$data12.Email) && !values.email && !isDisabled ? /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle2",
        color: 'red'
    }, "Please enter email id") : /*#__PURE__*/ React.createElement(React.Fragment, null), /*#__PURE__*/ React.createElement(InputLabel, null, t("Address")), /*#__PURE__*/ React.createElement(InputBox, {
        size: "small",
        id: "address",
        style: {
            marginTop: '8px'
        },
        value: getCustomerInfo && getCustomerInfo !== null && getCustomerInfo !== void 0 && (_getCustomerInfo$data13 = getCustomerInfo.data) !== null && _getCustomerInfo$data13 !== void 0 && _getCustomerInfo$data13.Address && (getCustomerInfo === null || getCustomerInfo === void 0 || (_getCustomerInfo$data14 = getCustomerInfo.data) === null || _getCustomerInfo$data14 === void 0 || (_getCustomerInfo$data14 = _getCustomerInfo$data14.Address) === null || _getCustomerInfo$data14 === void 0 ? void 0 : _getCustomerInfo$data14.length) > 0 && getCustomerInfo !== null && getCustomerInfo !== void 0 && (_getCustomerInfo$data15 = getCustomerInfo.data) !== null && _getCustomerInfo$data15 !== void 0 && _getCustomerInfo$data15.Address[0].Address1 ? getCustomerInfo === null || getCustomerInfo === void 0 || (_getCustomerInfo$data16 = getCustomerInfo.data) === null || _getCustomerInfo$data16 === void 0 || (_getCustomerInfo$data16 = _getCustomerInfo$data16.Address[0]) === null || _getCustomerInfo$data16 === void 0 ? void 0 : _getCustomerInfo$data16.Address1 : "",
        name: "address1",
        onChange: handleInputChange,
        disabled: true
    }), /*#__PURE__*/ React.createElement(InputBox, {
        id: "multiline-input",
        multiline: true,
        rows: 2,
        style: {
            marginTop: '10px'
        },
        value: getCustomerInfo && getCustomerInfo !== null && getCustomerInfo !== void 0 && (_getCustomerInfo$data17 = getCustomerInfo.data) !== null && _getCustomerInfo$data17 !== void 0 && _getCustomerInfo$data17.Address && (getCustomerInfo === null || getCustomerInfo === void 0 || (_getCustomerInfo$data18 = getCustomerInfo.data) === null || _getCustomerInfo$data18 === void 0 || (_getCustomerInfo$data18 = _getCustomerInfo$data18.Address) === null || _getCustomerInfo$data18 === void 0 ? void 0 : _getCustomerInfo$data18.length) > 0 && getCustomerInfo !== null && getCustomerInfo !== void 0 && (_getCustomerInfo$data19 = getCustomerInfo.data) !== null && _getCustomerInfo$data19 !== void 0 && (_getCustomerInfo$data19 = _getCustomerInfo$data19.Address[0]) !== null && _getCustomerInfo$data19 !== void 0 && _getCustomerInfo$data19.Address2 ? getCustomerInfo === null || getCustomerInfo === void 0 || (_getCustomerInfo$data20 = getCustomerInfo.data) === null || _getCustomerInfo$data20 === void 0 || (_getCustomerInfo$data20 = _getCustomerInfo$data20.Address[0]) === null || _getCustomerInfo$data20 === void 0 ? void 0 : _getCustomerInfo$data20.Address2 : "",
        name: "address2",
        onChange: handleInputChange,
        disabled: true
    }), /*#__PURE__*/ React.createElement(InputLabel, null, t("Language preference")), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        id: "customer-language-dropdown",
        fullWidth: true,
        caption: t('LANGUAGE'),
        name: "language",
        value: values === null || values === void 0 ? void 0 : values.language,
        displayExpr: "Name",
        valueExpr: "id",
        onChange: handleInputChange,
        error: errors === null || errors === void 0 ? void 0 : errors.language,
        options: (LanguageList === null || LanguageList === void 0 ? void 0 : LanguageList.data) || [],
        disabled: isDisabled
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(InputLabel, null, t('Contact preference')), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiAutocomplete, {
        multiple: true,
        id: "contact-preference-dropdown",
        options: (_ContactPreferrenceLi2 = ContactPreferrenceList === null || ContactPreferrenceList === void 0 ? void 0 : ContactPreferrenceList.data) !== null && _ContactPreferrenceLi2 !== void 0 ? _ContactPreferrenceLi2 : [],
        getOptionLabel: function (option) { return option.Name; },
        onChange: handleContactPreferenceChange,
        value: values.contactPreferences,
        renderInput: function (params) {
            var _values$contactPrefer;
            return /*#__PURE__*/ React.createElement(TextField, _extends({}, params, {
                placeholder: (values === null || values === void 0 || (_values$contactPrefer = values.contactPreferences) === null || _values$contactPrefer === void 0 ? void 0 : _values$contactPrefer.length) == 0 ? t('SELECT_CONTACT_PREF_PLACEHOLDER') : '',
                size: "small",
                error: errors === null || errors === void 0 ? void 0 : errors.contactPreferences
            }));
        },
        renderTags: function (value, getTagProps) { return value === null || value === void 0 ? void 0 : value.map(function (option, index) { /*#__PURE__*/ return React.createElement(Chip, _extends({
            id: option === null || option === void 0 ? void 0 : option.Name,
            variant: "filled",
            label: option === null || option === void 0 ? void 0 : option.Name
            // deleteIcon={<img
            //     id={`${option?.Name}-close`}
            //     alt="close"
            //     height={5}
            //     width={5}
            //     src={CrossIcon}
            // />}
        }, getTagProps({
            index: index
        }), {
            size: "small",
            sx: {
                borderRadius: '6px',
                backgroundColor: 'white',
                border: '1px solid #DEE4EB',
                fontSize: "base"
            }
        })); }); },
        size: "small",
        sx: {
            width: '100%'
        },
        disabled: isDisabled,
        slotProps: {
            popper: {
                sx: {
                    zIndex: 1300
                }
            }
        }
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        width: "100%",
        direction: "column",
        justifyContent: "space-between",
        spacing: 1,
        paddingTop: 1
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        fullWidth: true,
        size: "medium",
        name: t("Update"),
        variant: "contained",
        onClick: function () {
            handleUpdateClick();
            trackButtonClick("ButtonClickEvent", "Customer_Update_Click", undefined);
        },
        disabled: isDisabled || isTimerActive,
        loading: loader.isLoaderOpen
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        fullWidth: true,
        size: "medium",
        name: t("Cancel"),
        onClick: handleClose,
        style: {
            border: '1px solid #DEE4EB',
            color: '#6A7682',
            fontWeight: 500,
            fontSize: 14
        }
    })))));
};
export default EditCustomerInfo;
